import { render, staticRenderFns } from "./reisen-view-nav.vue?vue&type=template&id=8de0131a"
import script from "./reisen-view-nav.vue?vue&type=script&lang=js"
export * from "./reisen-view-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports